/**
 * Liste légère {route, name} des pages de l'application, tenue à jour en
 * même temps que routes.js (source d'origine des libellés).
 *
 * Ce fichier ne doit importer AUCUN composant de page : il est consommé par
 * examples/Navbars/DashboardNavbar, qui est lui-même importé par les pages
 * (layouts/*) que routes.js importe. Un import direct de routes.js depuis
 * DashboardNavbar créerait un cycle (routes.js -> layouts/* ->
 * DashboardNavbar -> routes.js), provoquant une erreur au chargement
 * ("Cannot access '...' before initialization").
 */
const routeNames = [
  { name: "Dashboard", route: "/dashboard" },
  { name: "Types de texte", route: "/types-textes" },
  { name: "Domaines", route: "/domaines" },
  { name: "Textes réglementaires", route: "/textes-reglementaires" },
  { name: "Textes réglementaires", route: "/base-documentaire" },
  { name: "Procédures internes", route: "/procedures-internes" },
  { name: "Gestion des Risques", route: "/gestion-risques" },
  { name: "Contrôle & Audit", route: "/controle" },
  { name: "Suivi des recommandations", route: "/suivi-recommandations" },
  { name: "Notifications", route: "/notifications" },
  { name: "Utilisateurs", route: "/utilisateurs" },
  { name: "Institutions", route: "/institutions" },
  { name: "Newsletter", route: "/newsletter" },
  { name: "Profil", route: "/profil" },
  { name: "Analyse Texte", route: "/analyse-texte/:texteId" },
  { name: "Home", route: "/" },
  { name: "Home", route: "/home" },
  { name: "Sign In", route: "/authentication/sign-in" },
  { name: "Mot de passé oublié", route: "/authentication/forgot-password" },
  { name: "Réinitialisation mot de passe", route: "/authentication/reset-password" },
  { name: "Contact", route: "/contact" },
  { name: "Documentation", route: "/documentation" },
  { name: "Politique de confidentialité", route: "/politique-confidentialite" },
  { name: "Mentions légales", route: "/mentions-legales" },
];

export default routeNames;
